import { Page } from "@/models/page-models/Page";

export const ComplaintNew: Page = {
  "path": "new-complaint",
  "name": "New Complaint",
  "props": {
    "data": {
      "title": "New Complaint",
      "printable": "FALSE",
      "url": "new-complaint",
      "groups": [
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.complaintType",
                  "label": "Type of Complaint",
                  "disabled": "FALSE",
                  "items": "[\"Full Rejection\",\"Partial Rejection\",\"Awareness\"]",
                  "dropdownType": "static"
                },
                {
                  "type": "dropdown",
                  "variable": "formData.customer",
                  "label": "Select Customer",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "pushCustomerId",
                        "type": "fnPushToArray",
                        "arg1Key": "sourceVariable",
                        "arg1Value": "formData.customer",
                        "arg2Key": "destinationVariable",
                        "arg2Value": "fetchedData.invoiceSearch.q.customer"
                      },
                      "name": "pushCustomerId"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getInvoicesByCustomer",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.allInvoices",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.invoiceSearch"
                      },
                      "name": "getInvoicesByCustomer"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.customers.data",
                  "itemText": "name",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,customerAlias,{{__item}})"
                }
              ]
            },
            {
              "name": "2a",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.invoice",
                  "label": "Select Invoice",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getInvoiceDetails",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/invoice/{{formData.invoice}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.invoiceDetails"
                      },
                      "name": "getInvoiceDetails"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyFormattedOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getFormattedOrders",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyFormattedOrders",
                      "executeIf": "fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}})"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.allInvoices.data.docs",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,invoiceDescription,{{__item}})",
                  "dropdownType": "search",
                  "searchFunctions": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyInvoiceSearchId",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.invoiceSearch.q._id"
                      },
                      "name": "copyInvoiceSearchId"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getInvoicesByCustomer",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.allInvoices",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.invoiceSearch"
                      },
                      "name": "getInvoicesByCustomer"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "variable": "formData.defectiveOrder",
                  "label": "Select Order",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedOrder",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedOrder"
                      },
                      "name": "copySelectedOrder"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.invoiceDetails}}",
                  "items": "fetchedData.invOrders",
                  "itemText": "id.product.alias",
                  "itemValue": "id._id",
                  "formula": "fn(CONCAT,{{__item.id.product._id}}, ,fn(HELPER_FN,productAlias,{{__item.id.product}}))"
                }
              ],
              "showIf": "fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}})"
            },
            {
              "name": "2b",
              "pageItems": [
                {
                  "type": "dropdown",
                  "variable": "formData.invoice",
                  "label": "select Invoice",
                  "onChange": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "getInvoiceDetails",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v2/invoice/{{formData.invoice}}",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.invoiceDetails"
                      },
                      "name": "getInvoiceDetails"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "copyFormattedOrders",
                        "type": "fnCopyData",
                        "arg1Key": "sourceFn",
                        "arg1Value": "getFormattedOrders",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData",
                        "arg3Key": "append",
                        "arg3Value": "TRUE",
                        "arg4Key": "destinationKeyType",
                        "arg4Value": "Object"
                      },
                      "name": "copyFormattedOrders",
                      "executeIf": "fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}})"
                    }
                  ],
                  "disabled": "FALSE",
                  "items": "fetchedData.allInvoices.data.docs",
                  "itemText": "_id",
                  "itemValue": "_id",
                  "formula": "fn(HELPER_FN,invoiceDescription,{{__item}})",
                  "dropdownType": "search",
                  "searchFunctions": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copyInvoiceSearchId",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.invoiceSearch.q._id"
                      },
                      "name": "copyInvoiceSearchId"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "getInvoicesByCustomer",
                        "type": "fnGetData",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/invoice/search",
                        "arg2Key": "storeInVar",
                        "arg2Value": "fetchedData.allInvoices",
                        "arg3Key": "postData",
                        "arg3Value": "fetchedData.invoiceSearch"
                      },
                      "name": "getInvoicesByCustomer"
                    }
                  ]
                },
                {
                  "type": "dropdown",
                  "variable": "formData.defectiveCalloff",
                  "label": "Select Order",
                  "onVarUpdate": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "copySelectedOrder",
                        "type": "fnCopyData",
                        "arg1Key": "sourceKey",
                        "arg1Value": "__selectedObject",
                        "arg2Key": "destinationKey",
                        "arg2Value": "fetchedData.selectedOrder"
                      },
                      "name": "copySelectedOrder"
                    }
                  ],
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.invoiceDetails}}",
                  "items": "fetchedData.invoiceDetails.data.callOffs",
                  "itemText": "callOff.product.alias",
                  "itemValue": "callOff._id",
                  "formula": "fn(CONCAT,{{__item.callOff.product._id}}, ,fn(HELPER_FN,productAlias,{{__item.callOff.product}}))"
                }
              ],
              "showIf": "fn(NOT,fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}}))"
            },
            {
              "name": "3a",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Order Quantity",
                  "showIf": "{{fetchedData.selectedOrder}}",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,fn(HELPER_FN,kgToSellingUnitQuantity,{{fetchedData.selectedOrder.id}},{{fetchedData.selectedOrder.fg}},{{fetchedData.selectedOrder.quantity}}), ,{{fetchedData.selectedOrder.id.unit.unit2}},(s))"
                },
                {
                  "type": "input",
                  "variable": "formData.defectiveQuantity",
                  "label": "Estimated Defective Order Quantity",
                  "unit": "{{fetchedData.selectedOrder.id.unit.unit2}}",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedOrder}}"
                },
                {
                  "type": "label",
                  "label": "Estimated Value",
                  "showIf": "{{formData.defectiveOrder}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{{{fetchedData.selectedOrder.id.unitPrice}}*{{formData.defectiveQuantity}}}})"
                }
              ],
              "showIf": "fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}})"
            },
            {
              "name": "3b",
              "pageItems": [
                {
                  "type": "label",
                  "label": "Order quantity",
                  "showIf": "{{fetchedData.selectedOrder}}",
                  "labelType": "formula",
                  "formula": "fn(CONCAT,{{fetchedData.selectedOrder.quantity}}, ,{{fetchedData.selectedOrder.callOff.unit.unit2}},(s))"
                },
                {
                  "type": "input",
                  "variable": "formData.defectiveQuantity",
                  "label": "Estimated Defective Order Quantity",
                  "unit": "{{fetchedData.selectedOrder.callOff.unit.unit2}}",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedOrder}}"
                },
                {
                  "type": "label",
                  "label": "Estimated Value",
                  "showIf": "{{formData.defectiveCalloff}}",
                  "labelType": "formula",
                  "formula": "fn(HELPER_FN,currency,{{{{fetchedData.selectedOrder.callOff.unitPrice}}*{{formData.defectiveQuantity}}}})"
                }
              ],
              "showIf": "fn(NOT,fn(LENGTH,{{fetchedData.invoiceDetails.data.orders}}))"
            },
            {
              "name": "4",
              "pageItems": [
                {
                  "type": "input",
                  "variable": "formData.description",
                  "label": "Description",
                  "disabled": "FALSE",
                  "showIf": "{{fetchedData.selectedOrder}}"
                }
              ]
            }
          ],
          "type": "genericGroup"
        },
        {
          "type": "arrayGroup",
          "variable": "formData.pictures",
          "label": "Add Pictures",
          "disabled": "FALSE",
          "showIf": "{{fetchedData.selectedOrder}}",
          "arrayItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "fileupload",
                  "variable": "picture",
                  "label": "Picture",
                  "disabled": "FALSE",
                  "color": "primary",
                  "previewType": "no-preview"
                }
              ]
            }
          ]
        },
        {
          "groupItems": [
            {
              "name": "1",
              "pageItems": [
                {
                  "type": "button",
                  "label": "Create Complaint",
                  "onClick": [
                    {
                      "executionOrder": 1,
                      "pageFunction": {
                        "name": "createComplaint",
                        "type": "fnSubmit",
                        "arg1Key": "apiUrl",
                        "arg1Value": "/api/v1/customer-complaint/create",
                        "arg2Key": "postData",
                        "arg2Value": "formData",
                        "arg3Key": "storeResponse",
                        "arg3Value": "TRUE"
                      },
                      "name": "createComplaint"
                    },
                    {
                      "executionOrder": 2,
                      "pageFunction": {
                        "name": "redirectToComplaintEdit",
                        "type": "fnRedirect",
                        "arg1Key": "redirectUrl",
                        "arg1Value": "/complaint/{{__response.data._id}}"
                      },
                      "name": "redirectToComplaintEdit",
                      "executeIf": "fn(LOGICAL,{{__response.data._id}},>,-1)"
                    }
                  ],
                  "disabled": "FALSE",
                  "color": "primary"
                }
              ]
            }
          ],
          "type": "genericGroup"
        }
      ],
      "useMaxPageWidth": true
    },
    "initialFunctionsCalled": [
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyDefaultCustomerForm",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultCustomerForm",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.customerForm",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "copyDefaultCustomerForm"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getCustomers",
        "executeIf": "fn(NOT,fn(MATCH_ROLE,Sales | Account Executive))"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "getMyCustomers",
          "type": "fnGetData",
          "arg1Key": "apiUrl",
          "arg1Value": "/api/v2/my-customers",
          "arg2Key": "storeInVar",
          "arg2Value": "fetchedData.customers",
          "arg3Key": "postData",
          "arg3Value": "fetchedData.customerForm"
        },
        "name": "getMyCustomers",
        "executeIf": "fn(MATCH_ROLE,Sales | Account Executive)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "copyCustomerId",
          "type": "fnCopyData",
          "arg1Key": "sourceKey",
          "arg1Value": "__query.customer",
          "arg2Key": "destinationKey",
          "arg2Value": "formData.customer",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Number"
        },
        "name": "copyCustomerId",
        "executeIf": "fn(LOGICAL,{{__query.customer}},>,0)"
      },
      {
        "executionOrder": 1,
        "pageFunction": {
          "name": "resetInvoiceSearchFilters",
          "type": "fnCopyData",
          "arg1Key": "sourceFn",
          "arg1Value": "getDefaultFilters",
          "arg2Key": "destinationKey",
          "arg2Value": "fetchedData.invoiceSearch",
          "arg3Key": "destinationKeyType",
          "arg3Value": "Object",
          "arg4Key": "append",
          "arg4Value": "TRUE"
        },
        "name": "resetInvoiceSearchFilters"
      }
    ],
    "functions": [
      {
        "name": "getDefaultFilters",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "q": {
            "status": [ "Approved", "Settled" ]
          },
          "page": 1,
          "limit": 50
        },
        "staticObject": true
      },
      {
        "name": "getFormattedOrders",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "invOrders": "fn(HELPER_FN,mergeInvoiceOrderFg,{{fetchedData.invoiceDetails.data}})"
        },
        "useFormula": true
      },
      {
        "name": "getDefaultCustomerForm",
        "type": "fnCreateObjectFromKeys",
        "newKeyValues": {
          "showDisabled": true,
          "status": ["Open Prospect", "Open Customer", "Closed Customer"]
        },
        "staticObject": true
      }
    ]
  },
  "forRole": "SALES_MANAGER,SALES_ACCOUNT_EXECUTIVE,GENERAL_MANAGER",
  "visible": false,
  "routerPriority": 50
}